import { resolveAdminMenuTarget } from '@/router/admin-menu-url'
import type { AdminMenuRouteSource } from '@/shared/types/admin'

import {
  resolveAdminMenuLabel,
  type AdminMenuTranslator
} from './menu-presentation'

export interface AdminMenuBreadcrumb {
  id: string | number
  title: string
}

const findMenuTrail = (
  items: readonly AdminMenuRouteSource[],
  routePath: string,
  translate: AdminMenuTranslator,
  parents: AdminMenuBreadcrumb[]
): AdminMenuBreadcrumb[] => {
  for (const item of items) {
    const current = [...parents, {
      id: item.id,
      title: resolveAdminMenuLabel(item, translate)
    }]
    const target = resolveAdminMenuTarget(item)
    if (target.kind === 'route' && target.routePath === routePath) {
      return current
    }

    const childTrail = findMenuTrail(item.children || [], routePath, translate, current)
    if (childTrail.length) return childTrail
  }

  return []
}

/** 从后端菜单树恢复当前页面的完整父子层级，整页刷新后仍可重复计算。 */
export const resolveAdminMenuBreadcrumbs = (
  items: readonly AdminMenuRouteSource[],
  routePath: string,
  translate: AdminMenuTranslator,
  currentTitleOverride?: string
): AdminMenuBreadcrumb[] => {
  const breadcrumbs = findMenuTrail(items, routePath, translate, [])
  const override = currentTitleOverride?.trim()
  if (!breadcrumbs.length || !override) return breadcrumbs

  return breadcrumbs.map((breadcrumb, index) => index === breadcrumbs.length - 1
    ? { ...breadcrumb, title: override }
    : breadcrumb)
}
